<!--<div *ngFor="let l of CurrentActorLicensesInfoController">
  <div class="comon-box  eh-box pb-0" *ngIf="ShowList" >
    <div class="row pl-3 pr-3 margin-left-zero border-bottom">
      <div class="col-md-12 add-new-cerit">
        <div class="edit-tools">
          <a (click)="edit_(l)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 "><i class="fas fa-pencil-alt"></i></a>
          <a (click)="del_(l.ActorCredentialCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 "><i class="far fa-trash-alt"></i></a>
          <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink"> <i class="fas fa-paperclip"></i> </a>

        </div>

        <div class="col-md-10 add-new-cerit ">
          <div class="row">



            <div class="col-md-4">
              <div class="form-group">
                <label>License Type</label>
                <span class="form-result">{{l.CredentialType}}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Licensing State</label>
                <span class="form-result">{{l.IssuingAuthorityLongValue}}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>License Number</label>
                <span class="form-result">{{l.CredentialNumber}}</span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Valid From</label>
                <span class="form-result">{{l.ValidFrom | date:'MMM-dd-yyyy'}} </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Valid To</label>
                <span class="form-result">{{l.ValidTo | date:'MMM-dd-yyyy'}}</span>
              </div>
            </div>


          </div>
          </div>
        </div>
      </div>
  </div>
</div>-->
<div class="card-content profile-eduction " *ngIf="ShowList">
  <div class="panel-heading">
    <div class="row">
      <div class="col-12">
        
        <div class="table-component">
          <div class="table-responsive">
            <table class="table  profile-table">
              <thead class="profile-thead ">
                <tr>
                  <th scope="col">License Type</th>
                  <th scope="col">Licensing State</th>
                  <th scope="col">License Number</th>
                  <th scope="col">Valid From</th>
                  <th scope="col">Valid To</th>
                  <th scope="col">Action</th>
                  

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let l of CurrentActorLicensesInfoController">
                  <td>{{l.CredentialType}}</td>
                  <td>{{l.IssuingAuthority}}</td>
                  <td>{{l.CredentialNumber}}</td>
                  <td>{{l.ValidFrom | date:'MMM-dd-yyyy'}} </td>
                  <td>{{l.ValidTo | date:'MMM-dd-yyyy'}}</td>
                  

                  <td>
                    <div class="row">
                      <a (click)="edit_(l)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <a (click)="del_(l.ActorCredentialCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                      <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink">
                        <span class="badge">
                         <i class="fas fa-paperclip"></i>
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!--<div class="row">
  <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but">
    <button type="button" (click)="ExpandData()" class="btn btn-primary btn-sm"><i class="fas glyphicon-expand"></i>Expand</button>
  </div>
</div>-->
<div *ngIf='IsExpand'>
  <div class="row" *ngIf="ShowList">
    <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but">
      <button type="button" (click)="clearData()" class="btn btn-primary btn-sm"><!--<i class="fas fa-plus nav-link-hand"></i>--> Add New</button>
    </div>
  </div>
  <div *ngIf='isNew && !ShowList'>
    <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

      <div class="comon-box  margin-left-zero p-0">
        <h4 class="heading-pinkbg mt-0">Add New License</h4>
        <div class="row pl-3 pr-3 margin-left-zero">


          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput1"><span>*</span> License Type </label>
            <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorLicenses" id="CurrentActorLicenseRequest.CredentialTypeCode"
                                     [(ngModel)]="CurrentActorLicenseRequest.CredentialTypeCode" name="CurrentActorLicenseRequest.CredentialTypeCode" required
                                     (keyChange)="onCredentialTypeByGroup($event)"
                                     #CredentialTypeCode="ngModel">
            </CustomDataByRequestType>
            <small class="form-text text-danger"
                   *ngIf="(!CredentialTypeCode.valid && (CredentialTypeCode.dirty || CredentialTypeCode.touched) && CredentialTypeCode.errors.required )">(Field cannot be left blank)</small>
          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput2">License Number</label>
            <input type="text" class="form-control" id="CurrentActorLicenseRequest.CredentialNumber"
                   [(ngModel)]="CurrentActorLicenseRequest.CredentialNumber"
                   name="CurrentActorLicenseRequest.CredentialNumber"
                   placeholder="License Number" maxlength="50" #CredentialNumber="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
            <small class="form-text text-danger"
                   *ngIf="(!CredentialNumber.valid && CredentialNumber.errors.pattern)">(special characters are not allowed)</small>
          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput4">Valid From</label>
            <!--<input type="date" class="form-control" id="CurrentActorLicenseRequest.ValidFrom" [(ngModel)]="CurrentActorLicenseRequest.ValidFrom" name="CurrentActorLicenseRequest.ValidFrom" placeholder="ValidFrom">-->
            <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="ValidFrom" class="form-control" [owlDateTime]="ValidFrom"
             [max]="MaxDateV"
             id="CurrentActorLicenseRequest.ValidFrom"
             placeholder="Issue Date"
             [(ngModel)]="CurrentActorLicenseRequest.ValidFrom"
             name="CurrentActorLicenseRequest.ValidFrom">
      <owl-date-time [pickerType]="'calendar'" #ValidFrom></owl-date-time>
    </div>-->
            <div class="date-form">
              <input class="form-control" placeholder="Valid From" [minDate]="minDate" [maxDate]="IssuemaxDate"
                     name="dp" [(ngModel)]="ValidFrom" ngbDatepicker #d="ngbDatepicker">

              <a (click)="d.toggle()" class="nav-link-hand">
                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

              </a>

            </div>

          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Valid To</label>
            <!--<input type="date" class="form-control" id="CurrentActorLicenseRequest.ValidTo" [(ngModel)]="CurrentActorLicenseRequest.ValidTo" name="CurrentActorLicenseRequest.ValidTo" placeholder="ValidTo">-->
            <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="ValidTo" class="form-control" [owlDateTime]="ValidTo"
             [max]="MaxDateV"
             id="CurrentActorLicenseRequest.ValidTo"
             placeholder="Expiring Date"
             [(ngModel)]="CurrentActorLicenseRequest.ValidTo"
             name="CurrentActorLicenseRequest.ValidTo">
      <owl-date-time [pickerType]="'calendar'" #ValidTo></owl-date-time>
    </div>-->
            <div class="date-form">
              <input class="form-control" placeholder="Valid To" [minDate]="minDate" [maxDate]="maxDate"
                     name="dp1" [(ngModel)]="ValidTo" ngbDatepicker #d1="ngbDatepicker">

              <a (click)="d1.toggle()" class="nav-link-hand">
                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

              </a>

            </div>
          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Licensing State</label>
            <CodeTypeValue CodeType="STATE" id="CurrentActorLicenseRequest.IssuingAuthority"
                           [(ngModel)]="CurrentActorLicenseRequest.IssuingAuthority"
                           name="CurrentActorLicenseRequest.IssuingAuthority"
                           SelectedValue="{{CurrentActorLicenseRequest.IssuingAuthority}}"
                           #IssuingAuthority="ngModel"></CodeTypeValue>

            <!--<CodeTypeValue CodeType="CTIAT" id="CurrentActorLicenseRequest.IssuingAuthority"
         [(ngModel)]="CurrentActorLicenseRequest.IssuingAuthority" name="CurrentActorLicenseRequest.IssuingAuthority"
         SelectedValue=""></CodeTypeValue>-->
            <small class="form-text text-danger"
                   *ngIf="(!IssuingAuthority.valid && IssuingAuthority.errors.pattern)">(special characters are not allowed)</small>
          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Additional Details</label>
            <input type="text" class="form-control" id="CurrentActorLicenseRequest.AdditionalDetails"
                   [(ngModel)]="CurrentActorLicenseRequest.AdditionalDetails" #AdditionalDetails="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                   name="CurrentActorLicenseRequest.AdditionalDetails" placeholder="Additional Details" maxlength="100">
            <small class="form-text text-danger"
                   *ngIf="(!AdditionalDetails.valid && AdditionalDetails.errors.pattern)">(special characters are not allowed)</small>
          </div>
          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Remarks</label>
            <input type="text" class="form-control" id="CurrentActorLicenseRequest.Remarks"
                   [(ngModel)]="CurrentActorLicenseRequest.Remarks" #Remarks="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                   name="CurrentActorLicenseRequest.Remarks" placeholder="Remarks" maxlength="100">
            <small class="form-text text-danger"
                   *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
          </div>

          <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Save</button>

  </div>-->
          <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          <!--<div class="row">
            <div class="card-footer text-right col-12">
              <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">Cancel</button>
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Save</button>

            </div>
          </div>-->
        </div>


      </div>

      <div class="row" *ngIf="CanEdit === 1 ">
        <div class="card-footer text-right col-12">
          <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">Cancel</button>
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Save</button>

        </div>
      </div>





    </form>
  </div>
  <div *ngIf='isEdit && !ShowList'>
    <form class="form" novalidate="" (ngSubmit)="onEditSubmit()" #ff="ngForm">

      <div class="comon-box p-0 margin-left-zero">
        <h4 class="heading-pinkbg mt-0">Update License</h4>
        <div class="row pl-3 pr-3 margin-left-zero">


          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput1"><span>*</span> License Type  </label>
            <!--<CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorLicenses" id="CurrentActorEditLicenseRequest.CredentialTypeCode"
                                     [(ngModel)]="CurrentActorEditLicenseRequest.CredentialTypeCode" name="CurrentActorEditLicenseRequest.CredentialTypeCode" required
                                     (keyChange)="onCredentialTypeEditByGroup($event)" #UCredentialTypeCode="ngModel">
            </CustomDataByRequestType>
            <small class="form-text text-danger"
                   *ngIf="(!UCredentialTypeCode.valid && (UCredentialTypeCode.dirty || UCredentialTypeCode.touched) && UCredentialTypeCode.errors.required )">(Field cannot be left blank)</small>-->
            <label class="margin-left-10px color-text">{{CurrentActorEditLicenseRequest.CredentialType}}</label>
          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput2">License Number</label>
            <input type="text" class="form-control" id="CurrentActorEditLicenseRequest.CredentialNumber"
                   [(ngModel)]="CurrentActorEditLicenseRequest.CredentialNumber" #UCredentialNumber="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                   name="CurrentActorEditLicenseRequest.CredentialNumber" placeholder="License Number" maxlength="50">
            <small class="form-text text-danger"
                   *ngIf="(!UCredentialNumber.valid && UCredentialNumber.errors.pattern)">(special characters are not allowed)</small>
          </div>


          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput4">
              Valid From
            </label>

            <!--<input #myDatePicker type="date" class="form-control"
            value='{{ CurrentActorEditLicenseRequest.ValidFrom | date:"yyyy-MM-dd" }}'
            (input)="onInputValidFrom(myDatePicker.value)"
            placeholder="Issue Date" />-->
            <!--<div *ngIf="CanAdjustgetTimezoneOffset">
              <input [owlDateTimeTrigger]="ValidFrom" class="form-control" [owlDateTime]="ValidFrom"
                     [max]="MaxDateV"
                     id="CurrentActorEditLicenseRequest.ValidFrom"
                     placeholder="Issue Date"
                     [(ngModel)]="CurrentActorEditLicenseRequest.ValidFrom"
                     name="CurrentActorEditLicenseRequest.ValidFrom">
              <owl-date-time [pickerType]="'calendar'" #ValidFrom></owl-date-time>
            </div>-->
            <!--<input type="date" class="form-control" id="CurrentActorEditLicenseRequest.ValidFrom"
            [(ngModel)]="CurrentActorEditLicenseRequest.ValidFrom" name="CurrentActorEditLicenseRequest.ValidFrom" placeholder="ValidFrom">-->
            <div class="date-form">
              <input class="form-control" placeholder="Valid From" [minDate]="minDate" [maxDate]="IssuemaxDate"
                     name="dp" [(ngModel)]="ValidFrom" ngbDatepicker #d="ngbDatepicker">

              <a (click)="d.toggle()" class="nav-link-hand">
                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

              </a>


            </div>

          </div>


          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Valid To</label>
            <!--<input #myDatePicker1 type="date" class="form-control"
            value='{{ CurrentActorEditLicenseRequest.ValidTo | date:"yyyy-MM-dd" }}'
            (input)="onInputValidTo(myDatePicker1.value)"
            placeholder="Expiring Date" />-->
            <!--<div *ngIf="CanAdjustgetTimezoneOffset">
              <input [owlDateTimeTrigger]="ValidTo" class="form-control" [owlDateTime]="ValidTo"
                     [max]="MaxDateV"
                     id="CurrentActorEditLicenseRequest.ValidTo"
                     placeholder="Expiring Date"
                     [(ngModel)]="CurrentActorEditLicenseRequest.ValidTo"
                     name="CurrentActorEditLicenseRequest.ValidTo">
              <owl-date-time [pickerType]="'calendar'" #ValidTo></owl-date-time>
            </div>-->
            <div class="date-form">
              <input class="form-control" placeholder="Valid To" [minDate]="minDate" [maxDate]="maxDate"
                     name="dp1" [(ngModel)]="ValidTo" ngbDatepicker #d1="ngbDatepicker">

              <a (click)="d1.toggle()" class="nav-link-hand">
                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

              </a>

            </div>

            <!--<input type="date" class="form-control" id="CurrentActorEditLicenseRequest.ValidTo"
            [(ngModel)]="CurrentActorEditLicenseRequest.ValidTo" name="CurrentActorEditLicenseRequest.ValidTo" placeholder="ValidTo">-->
          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Licensing State</label>

            <CodeTypeValue CodeType="CTIAT" id="CurrentActorEditLicenseRequest.IssuingAuthority"
                           [(ngModel)]="CurrentActorEditLicenseRequest.IssuingAuthority" name="CurrentActorEditLicenseRequest.IssuingAuthority"
                           SelectedValue="{{CurrentActorEditLicenseRequest.IssuingAuthority}}"></CodeTypeValue>
          </div>

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Additional Details</label>
            <input type="text" class="form-control" id="CurrentActorEditLicenseRequest.AdditionalDetails"
                   [(ngModel)]="CurrentActorEditLicenseRequest.AdditionalDetails" #UAdditionalDetails="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                   name="CurrentActorEditLicenseRequest.AdditionalDetails" placeholder="Additional Details" maxlength="100">
            <small class="form-text text-danger"
                   *ngIf="(!UAdditionalDetails.valid && UAdditionalDetails.errors.pattern)">(special characters are not allowed)</small>
          </div>
          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Remarks</label>
            <input type="text" class="form-control" id="CurrentActorEditLicenseRequest.Remarks"
                   [(ngModel)]="CurrentActorEditLicenseRequest.Remarks" #URemarks="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                   name="CurrentActorEditLicenseRequest.Remarks" placeholder="Remarks" maxlength="100">
            <small class="form-text text-danger"
                   *ngIf="(!URemarks.valid && URemarks.errors.pattern)">(special characters are not allowed)</small>
          </div>

          <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Update</button>

          </div>-->
          <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>


      </div>


      <div class="row" *ngIf="CanEdit === 1 ">
        <div class="card-footer text-right col-12">
          <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3">Cancel</button>
          <button type="submit" [disabled]="!ff.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Update</button>

        </div>
      </div>




    </form>
  </div>
</div>


<!--<div class="row">
  <div class="form-group col-md-12 col-xs-12 mt-5"><a href="#finish" role="menuitem" class="btn-blue-main">Save</a></div>
</div>-->
